import { useState } from "react";

import { useUserInfoContext } from "@/contexts";
import authAxiosInstance from "@/sevices/authAxiosInstance";
import { Invoice } from "@/types/Invoice";
import { getErrorMessage } from "@/utils/Errors/getErrorMessage";

export const useInvoiceDetail = () => {
  const [invoiceDetail, setInvoiceDetail] = useState<Invoice | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { userInfo } = useUserInfoContext() as {
    userInfo: { userId: string };
  };

  const fetchInvoice = async (invoiceNum: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await authAxiosInstance({
        url: `/invoiceservice/api/v1/invoice/${invoiceNum}`,
        method: "GET",
        params: { userId: userInfo?.userId }
      });
      const data = response.data;
      setInvoiceDetail(data);
      return data;
    } catch (err) {
      setError(getErrorMessage("invoiceErrors", err));
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    fetchInvoice,
    invoiceDetail,
    isLoading,
    error,
    setInvoiceDetail,
    setIsLoading,
    setError
  };
};
